import React, { useState } from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { useTheme } from '../contexts/ThemeContext';

const isWeb = Platform.OS === 'web';

// Generic tooltip wrapper: renders children and shows tooltip on hover (web) or long-press (mobile)
const Tooltip = ({ children, content, position = 'top' }) => {
  const { colors } = useTheme();
  const [visible, setVisible] = useState(false);

  const triggerProps = isWeb
    ? { onMouseEnter: () => setVisible(true), onMouseLeave: () => setVisible(false) }
    : { onLongPress: () => { setVisible(true); setTimeout(() => setVisible(false), 1200); } };

  const posStyle = position === 'top'
    ? { bottom: 28, left: '50%', transform: [{ translateX: -100 }] }
    : position === 'bottom'
    ? { top: 28, left: '50%', transform: [{ translateX: -100 }] }
    : position === 'left'
    ? { right: 28, top: '50%', transform: [{ translateY: -20 }] }
    : { left: 28, top: '50%', transform: [{ translateY: -20 }] };

  return (
    <View style={styles.container} {...triggerProps}>
      {children}
      {visible && (
        <View
          style={[
            styles.tooltip,
            posStyle,
            { backgroundColor: colors.text },
            // Ensure tooltip never blocks clicks on underlying buttons (web)
            { pointerEvents: 'none' },
          ]}
        >
          <Text style={[styles.tooltipText, { color: colors.background }]}>{content}</Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    marginLeft: 4,
  },
  tooltip: {
    position: 'absolute',
    backgroundColor: '#333',
    padding: 8,
    borderRadius: 6,
    minWidth: 200,
    maxWidth: 250,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    zIndex: 1000,
  },
  tooltipText: {
    color: 'white',
    fontSize: 12,
    textAlign: 'center',
    lineHeight: 16,
  },
});

export default Tooltip;